export default "__VITE_ASSET__BVrXxc0Z__"